import React from 'react';
import { checklistLabel, clinicalScopeNote, workflowChecklist } from '../../data/clinicalDemo';
import { DemoSectionHeader } from '../demoShell/DemoSectionHeader';
import { glassPanel } from '../../utils/demoUi';
export function WorkflowReferences() {
  return <div data-id="element-208" data-mp="opr9r6kq89l">
      <DemoSectionHeader title="Workflow References" description="A documentation checklist used throughout this demonstration." data-id="element-209" data-mp="3suv03sxbez8l" />
      <section aria-labelledby="checklist-title" className={`${glassPanel} max-w-3xl p-6 lg:p-8`} data-id="element-210" data-mp="3nw1v6ow3ggk1">
        <p className="rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm font-semibold text-amber-900" data-id="element-211" data-mp="3iwfgsc4j4u9n">{checklistLabel}</p>
        <h2 id="checklist-title" className="mt-5 font-heading text-xl font-bold text-ink-dark" data-id="element-212" data-mp="3dxvu29i43eg8">
          Documentation checklist
        </h2>
        <ol className="mt-4 space-y-3" data-id="element-213" data-mp="1c5zcai5cp8d0">
          {workflowChecklist.map((item, index) => <li key={item} className="grid grid-cols-[2rem_1fr] gap-3" data-id="element-214" data-mp="184x95q8bcc5r" data-mpi={index}>
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-lavender-pale text-sm font-semibold text-lavender" data-id="element-215" data-mp="182jhlrcudi2y">{index + 1}</span>
              <span className="pt-0.5 leading-relaxed text-ink-dark" data-id="element-216" data-mp="2gpey5bkkrkvn">{item}</span>
            </li>)}
        </ol>
      </section>
      <p className="mt-6 max-w-3xl text-sm leading-relaxed text-ink-muted" data-id="element-217" data-mp="22qp4y70vm5ck">{clinicalScopeNote}</p>
    </div>;
}